import React from 'react';
import Icon from './Icon';

/**
 * Alert chip — pill with leading alert glyph + short text. Two kinds:
 *   critical → --danger / --danger-soft
 *   warning  → --warning / --warning-soft
 *
 * Used on the bottom of project cards to surface schedule/financial
 * exceptions ("2 tasks behind schedule", "Retainage held > 10%", etc.).
 * Keep `text` short — these are not full sentences.
 */
export default function AlertChip({ kind = 'warning', text }) {
  const c =
    kind === 'critical'
      ? { fg: 'var(--danger)', bg: 'var(--danger-soft)' }
      : { fg: 'var(--warning)', bg: 'var(--warning-soft)' };
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        padding: '4px 8px',
        borderRadius: 6,
        fontSize: 13,
        fontWeight: 500,
        color: c.fg,
        background: c.bg,
        border: `1px solid color-mix(in oklch, ${c.fg} 18%, transparent)`,
        lineHeight: 1.3,
      }}
    >
      <Icon name="alert" size={11} />
      {text}
    </span>
  );
}
